import { useQuery } from '@tanstack/react-query';
import { Link, useParams } from 'react-router-dom';
import { api } from '../api/client';
import { PageHeader } from '../components/Layout';
import { Card, JsonBlock, KeyValue, QueryBoundary } from '../components/ui';
import { dateTime, num } from '../lib/format';

export default function DatasetDetail() {
  const { hash } = useParams<{ hash: string }>();
  const q = useQuery({
    queryKey: ['dataset', hash],
    queryFn: () => api.dataset(hash as string),
    enabled: Boolean(hash),
  });
  const d = q.data;

  return (
    <>
      <PageHeader
        title="Dataset"
        description={hash}
        actions={
          <Link className="text-sm text-sky-400 hover:underline" to="/datasets">
            ← all datasets
          </Link>
        }
      />
      <QueryBoundary q={q}>
        {d && (
          <div className="space-y-5">
            <Card className="p-4">
              <KeyValue
                rows={[
                  ['Strategy', d.strategy_id],
                  ['Feature set', d.feature_set_version],
                  ['Symbols', d.symbols.join(', ')],
                  ['Timeframe', d.timeframe],
                  ['Range', `${dateTime(d.from_utc)} → ${dateTime(d.to_utc)}`],
                  ['Built', dateTime(d.built_at_utc)],
                  ['Rows', num(d.row_count, 0)],
                  ['Positive (target-first)', num(d.positive_count, 0)],
                  ['Time-barrier', num(d.time_barrier_count, 0)],
                  ['Ambiguous (excluded)', num(d.ambiguous_count, 0)],
                  ['Excluded — permanently missing', num(d.excluded_permanently_missing, 0)],
                  ['Models trained on it', d.model_count],
                ]}
              />
            </Card>
            <Card className="p-4">
              <h2 className="mb-3 text-sm font-medium text-slate-300">Label config</h2>
              <JsonBlock value={d.label_config} />
            </Card>
            <p className="text-sm">
              <Link className="text-sky-400 hover:underline" to={`/models?strategy_id=${d.strategy_id}`}>
                Models for {d.strategy_id} →
              </Link>
            </p>
          </div>
        )}
      </QueryBoundary>
    </>
  );
}
